<template>
  <v-layout ref="downloadImage" id="section-to-print" class="mb-3 w-100">
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="3"
        xl="3"
        v-for="item in listProduct"
        :key="item.product_id"
      >
        <card :item="item">
          <v-chip-group column class="text-center">
            <tooltip-chip color="#65c5fe" content="Harga Starter">
              {{
                calcPrice(
                  item.product_price,
                  item.discount_percent_reseller_starter
                )
              }}
            </tooltip-chip>
            <tooltip-chip color="#f0c131" content="Harga Bisnis">
              {{
                calcPrice(
                  item.product_price,
                  item.discount_percent_reseller_bisnis
                )
              }}
            </tooltip-chip>
            <tooltip-chip color="#9231fd" content="Harga Enterprise">
              {{
                calcPrice(
                  item.product_price,
                  item.discount_percent_reseller_enterprise
                )
              }}
            </tooltip-chip>
          </v-chip-group>
        </card>
      </v-col>
    </v-row>
 
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";
import { toPng } from "html-to-image";
import card from "./components/card.vue";
import tooltipChipVue from "./components/tooltipChip.vue";
export default {
  components: {
    card: card,
    "tooltip-chip": tooltipChipVue,
  },
  data() {
    return {
      supplier: "",
      listProduct: "",
      loadingProduct: false,
    };
  },
  mounted() {
    let id = this.$route.query.supplier;
    if (!id) {
      alert("Supplier tidak ditemukan");
    } else {
      this.getProduct(id).then(() => this.downloadPNG())
    }
  },
  methods: {
    async downloadPNG() {
      const el = this.$refs.downloadImage;
      const now = new Date();
      const unixTime = Math.floor(now.getTime() / 1000);

      if (el === null) {
        return;
      }

      //   this.isLoadingImage = true;

      await toPng(el, { backgroundColor: "#f7f7f7" })
        .then((dataUrl) => {
          const link = document.createElement("a");
          link.download = `Katalog-${unixTime}.png`;
          link.href = dataUrl;
          link.click();
          console.log("load");
        })
        .catch((err) => {
          console.log(err);
        });

      //   this.isLoadingImage = false;
    },
    ...mapActions("pembelianSeller", ["getListProdukPrint"]),
    async getProduct(id) {
      return new Promise(async (resolve) => {
        this.loadingProduct = true;
        await this.getListProdukPrint({
          page: 1,
          limit: 100000,
          supplier_id: id,
        })
          .then((res) => {
            this.listProduct = [...res.data];
          })
          .catch(() => {
            this.loadingProduct = false;
          });
          resolve()
      });
    },
    calcPrice(price, percent) {
      let val = Number(price) * (Number(percent) / 100);
      return (Number(price) - val).toLocaleString("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>